<div *ngIf="lessonCards" class="flex"  [@all]="currentState" >
    <div *ngFor="let lesson of lessonCards | async; let i = index "  class = "lessonContainer" >
            <img alt="Lesson Tile Image" src={{lesson.img}} class="lessonPhoto" (click)="gotoLessonHeader(lesson)"       
            [@guideAnimation]="guideTriggers[i]" 
            (mouseenter)="setMouse('hover', lesson)"
            (mousedown)="setMouse('press', lesson)" 
            (mouseleave)="setMouse('rest', lesson)" 
            (@mouse.done)="animateEnd($event)"
            [@mouse]="mouseTriggers[i]">
            
            <div *ngIf="!lesson.unlocked && !authLevel" class="cover "><span class="coverText darkGreyText regularText">LOCKED</span></div>
            <div class="greyText lessonIndex captionText center">{{config?.guide}} {{lesson.id}}</div>
            <div *ngIf="config?.lessonsCards" class="darkGreyText lessonTitle regularText">{{config.lessonsCards[lesson.id - 1].title}}</div>
    </div>
</div>